export enum CallStopPurposeEnum {
  Pickup = "Pickup",
  Dropoff = "Dropoff",
  Operation = "Operation"
}
